export function edit_url_fragment(
  customer_id: string,
  language_code: string,
): string {
  return `company_cv/${language_code}/customer/${customer_id}`;
}

export function edit_path(customer_id: string, language_code: string): string {
  const fragment = edit_url_fragment(customer_id, language_code);

  return `/tools#/${fragment}`;
}
